import { StarDisplay } from 'components/StarDisplay';

import * as styled from '../styles';
import { TESTIMONIALS } from '../constants';

export const TestimonialsSection = () => (
  <styled.TestimonialsSection>
    <styled.TestimonialsHeading>
      What service providers are saying
    </styled.TestimonialsHeading>
    {TESTIMONIALS.map((testimonial) => (
      <styled.TestimonialCard key={testimonial.name}>
        <styled.TestimonialQuote>"{testimonial.quote}"</styled.TestimonialQuote>
        <styled.TestimonialFooter>
          <styled.TestimonialAuthor>
            <styled.TestimonialName>{testimonial.name}</styled.TestimonialName>
            <styled.TestimonialMeta>
              {testimonial.title} · {testimonial.flag} {testimonial.country}
            </styled.TestimonialMeta>
          </styled.TestimonialAuthor>
          <StarDisplay value={testimonial.rating} size={14} />
        </styled.TestimonialFooter>
      </styled.TestimonialCard>
    ))}
  </styled.TestimonialsSection>
);
